import { render, staticRenderFns } from "./FormPopupItem.vue?vue&type=template&id=3ae8d9dc&scoped=true"
import script from "./FormPopupItem.vue?vue&type=script&lang=js"
export * from "./FormPopupItem.vue?vue&type=script&lang=js"
import style0 from "./FormPopupItem.vue?vue&type=style&index=0&id=3ae8d9dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8d9dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae8d9dc')) {
      api.createRecord('3ae8d9dc', component.options)
    } else {
      api.reload('3ae8d9dc', component.options)
    }
    module.hot.accept("./FormPopupItem.vue?vue&type=template&id=3ae8d9dc&scoped=true", function () {
      api.rerender('3ae8d9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/formItems/FormPopupItem.vue"
export default component.exports